import { useQuery } from '@apollo/client/react'
import {
  PORTAL_LIST_ORG_MEMBERS,
  type PortalListOrgMembersData,
  type PortalListOrgMembersVars,
  type OrgMember,
} from '../api/operations'

interface UseOrgMembersArgs {
  take: number
  skip: number
}

export function useOrgMembers({ take, skip }: UseOrgMembersArgs) {
  const { data, loading, error, refetch } = useQuery<
    PortalListOrgMembersData,
    PortalListOrgMembersVars
  >(PORTAL_LIST_ORG_MEMBERS, {
    variables: { take, skip },
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    members: data?.portalListOrgMembers.items ?? [],
    totalItems: data?.portalListOrgMembers.totalItems ?? 0,
    loading,
    error,
    refetch,
  }
}

export type { OrgMember }
